/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './image-upload.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '../shared/data.service';
import * as import9 from '@angular/core/src/metadata/view';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import12 from '@angular/core/src/linker/template_ref';
import * as import13 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import14 from '@angular/common/src/directives/ng_for';
import * as import15 from '../../../node_modules/@angular/common/src/directives/ng_style.ngfactory';
import * as import16 from '../../../node_modules/ng2-file-upload/file-upload/file-select.directive.ngfactory';
import * as import17 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import18 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import19 from '@angular/core/src/linker/element_ref';
import * as import20 from 'ng2-file-upload/file-upload/file-select.directive';
import * as import21 from '@angular/common/src/directives/ng_if';
import * as import22 from '@angular/common/src/directives/ng_style';
import * as import23 from '@angular/core/src/security';
export class Wrapper_ImageUploadComponent {
  context:import0.ImageUploadComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  /*private*/ _expr_7:any;
  constructor(p0:any) {
    this.changed = false;
    this.context = new import0.ImageUploadComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  check_form(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.form = currValue;
      this._expr_0 = currValue;
    }
  }
  check_groupName(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.groupName = currValue;
      this._expr_1 = currValue;
    }
  }
  check_imagePath(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.imagePath = currValue;
      this._expr_2 = currValue;
    }
  }
  check_addApi(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this.changed = true;
      this.context.addApi = currValue;
      this._expr_3 = currValue;
    }
  }
  check_deleteApi(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this.changed = true;
      this.context.deleteApi = currValue;
      this._expr_4 = currValue;
    }
  }
  check_deleteDir(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this.changed = true;
      this.context.deleteDir = currValue;
      this._expr_5 = currValue;
    }
  }
  check_images(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this.changed = true;
      this.context.images = currValue;
      this._expr_6 = currValue;
    }
  }
  check_thumbSize(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_7,currValue))) {
      this.changed = true;
      this.context.thumbSize = currValue;
      this._expr_7 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ImageUploadComponent_Host:import4.RenderComponentType = (null as any);
class _View_ImageUploadComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _ImageUploadComponent_0_4:Wrapper_ImageUploadComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_ImageUploadComponent_Host0,renderType_ImageUploadComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'image-uploads',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ImageUploadComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ImageUploadComponent_0_4 = new Wrapper_ImageUploadComponent(this.parentInjector.get(import8.DataService));
    this._appEl_0.initComponent(this._ImageUploadComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ImageUploadComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ImageUploadComponent) && (0 === requestNodeIndex))) { return this._ImageUploadComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ImageUploadComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ImageUploadComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._ImageUploadComponent_0_4.context.ngAfterViewInit(); } }
  }
}
function viewFactory_ImageUploadComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_ImageUploadComponent_Host === (null as any))) { (renderType_ImageUploadComponent_Host = viewUtils.createRenderComponentType('',0,import9.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ImageUploadComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ImageUploadComponentNgFactory:import10.ComponentFactory<import0.ImageUploadComponent> = new import10.ComponentFactory<import0.ImageUploadComponent>('image-uploads',viewFactory_ImageUploadComponent_Host0,import0.ImageUploadComponent);
const styles_ImageUploadComponent:any[] = [
  '.upload-tool[_ngcontent-%COMP%] {height: 20px; margin-top: -5px}',
  '.progress-cover[_ngcontent-%COMP%] {margin-right: 5px; float: left}',
  '.uploader[_ngcontent-%COMP%] {margin: 15px 10px 0px 0px}',
  '.clickLink[_ngcontent-%COMP%] {cursor: pointer}'
]
;
var renderType_ImageUploadComponent:import4.RenderComponentType = (null as any);
class _View_ImageUploadComponent0 extends import3.AppView<import0.ImageUploadComponent> {
  _text_0:any;
  _anchor_1:any;
  /*private*/ _appEl_1:import5.AppElement;
  _TemplateRef_1_5:any;
  _NgFor_1_6:import11.Wrapper_NgFor;
  _text_2:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_ImageUploadComponent0,renderType_ImageUploadComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n          ',(null as any));
    this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_1 = new import5.AppElement(1,(null as any),this,this._anchor_1);
    this._TemplateRef_1_5 = new import12.TemplateRef_(this._appEl_1,viewFactory_ImageUploadComponent1);
    this._NgFor_1_6 = new import11.Wrapper_NgFor(this._appEl_1.vcRef,this._TemplateRef_1_5,this.parentInjector.get(import13.IterableDiffers),this.ref);
    this._text_2 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this.init(([] as any[]),[
      this._text_0,
      this._anchor_1,
      this._text_2
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.TemplateRef) && (1 === requestNodeIndex))) { return this._TemplateRef_1_5; }
    if (((token === import14.NgFor) && (1 === requestNodeIndex))) { return this._NgFor_1_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1_0_0:any = this.context.uploaders;
    this._NgFor_1_6.check_ngForOf(currVal_1_0_0,throwOnChange,false);
    this._NgFor_1_6.detectChangesInInputProps(this,this._anchor_1,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ImageUploadComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.ImageUploadComponent> {
  if ((renderType_ImageUploadComponent === (null as any))) { (renderType_ImageUploadComponent = viewUtils.createRenderComponentType('',0,import9.ViewEncapsulation.Emulated,styles_ImageUploadComponent,{})); }
  return new _View_ImageUploadComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ImageUploadComponent1 extends import3.AppView<any> {
  _el_0:any;
  _NgStyle_0_3:import15.Wrapper_NgStyle;
  _text_1:any;
  _el_2:any;
  _FileSelectDirective_2_3:import16.Wrapper_FileSelectDirective;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import5.AppElement;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import17.Wrapper_NgIf;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import5.AppElement;
  _TemplateRef_7_5:any;
  _NgFor_7_6:import11.Wrapper_NgFor;
  _text_8:any;
  _text_9:any;
  _map_18:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_ImageUploadComponent1,renderType_ImageUploadComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_18 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {width: p0};
    });
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','uploader col-md-5'),(null as any));
    this._NgStyle_0_3 = new import15.Wrapper_NgStyle(this.parentInjector.get(import18.KeyValueDiffers),new import19.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'input',new import2.InlineArray8(6,'class','hidden','ng2FileSelect','','type','file'),(null as any));
    this._FileSelectDirective_2_3 = new import16.Wrapper_FileSelectDirective(new import19.ElementRef(this._el_2));
    this._text_3 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_5 = new import5.AppElement(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import12.TemplateRef_(this._appEl_5,viewFactory_ImageUploadComponent2);
    this._NgIf_5_6 = new import17.Wrapper_NgIf(this._appEl_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_7 = new import5.AppElement(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import12.TemplateRef_(this._appEl_7,viewFactory_ImageUploadComponent3);
    this._NgFor_7_6 = new import11.Wrapper_NgFor(this._appEl_7.vcRef,this._TemplateRef_7_5,this.parentInjector.get(import13.IterableDiffers),this.parent.ref);
    this._text_8 = this.renderer.createText(this._el_0,' ',(null as any));
    this._text_9 = this.renderer.createText(this._el_0,'\n            \n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'change',this.eventHandler(this._handle_change_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._text_9
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.FileSelectDirective) && (2 === requestNodeIndex))) { return this._FileSelectDirective_2_3.context; }
    if (((token === import12.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import21.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import12.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import14.NgFor) && (7 === requestNodeIndex))) { return this._NgFor_7_6.context; }
    if (((token === import22.NgStyle) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 9)))) { return this._NgStyle_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this._map_18((this.parent.context.thumbSize + 20));
    this._NgStyle_0_3.check_ngStyle(currVal_0_0_0,throwOnChange,false);
    this._NgStyle_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = this.context.$implicit;
    this._FileSelectDirective_2_3.check_uploader(currVal_2_0_0,throwOnChange,false);
    this._FileSelectDirective_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_5_0_0:any = (this.context.$implicit.queue.length == 0);
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = this.context.$implicit.queue;
    this._NgFor_7_6.check_ngForOf(currVal_7_0_0,throwOnChange,false);
    this._NgFor_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgStyle_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._FileSelectDirective_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_change_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.context.onChangeImageHandler(this.context.$implicit.options.itemAlias,$event)) !== false);
    const pd_2_1:any = ((<any>this._FileSelectDirective_2_3.context.onChange()) !== false);
    return ((true && pd_2_0) && pd_2_1);
  }
}
function viewFactory_ImageUploadComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_ImageUploadComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ImageUploadComponent2 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_ImageUploadComponent2,renderType_ImageUploadComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'img',new import2.InlineArray4(4,'class','clickLink','style','margin-top: 10px'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_1:any = import2.interpolate(1,'',this.parent.context.$implicit.options.itemAlias,'');
    if (import2.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'title',currVal_1);
      this._expr_1 = currVal_1;
    }
    const currVal_2:any = (this.parent.parent.context.form.controls[this.parent.parent.context.groupName].controls[this.parent.context.$implicit.options.itemAlias].value? (this.parent.parent.context.imagePath + this.parent.parent.context.form.controls[this.parent.parent.context.groupName].controls[this.parent.context.$implicit.options.itemAlias].value): (this.parent.parent.context.imagePath + this.parent.parent.context.defaultImage));
    if (import2.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setElementProperty(this._el_0,'src',this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL,currVal_2));
      this._expr_2 = currVal_2;
    }
    const currVal_3:any = import2.interpolate(1,'',this.parent.parent.context.thumbSize,'');
    if (import2.checkBinding(throwOnChange,this._expr_3,currVal_3)) {
      this.renderer.setElementProperty(this._el_0,'width',currVal_3);
      this._expr_3 = currVal_3;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>(<_View_ImageUploadComponent1>this.parent)._el_2.click()) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ImageUploadComponent2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_ImageUploadComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ImageUploadComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import17.Wrapper_NgIf;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _NgStyle_6_3:import15.Wrapper_NgStyle;
  _text_7:any;
  _el_8:any;
  _NgStyle_8_3:import15.Wrapper_NgStyle;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _map_40:any;
  _map_41:any;
  /*private*/ _expr_42:any;
  /*private*/ _expr_43:any;
  /*private*/ _expr_44:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_ImageUploadComponent3,renderType_ImageUploadComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_40 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {width: p0};
    });
    this._map_41 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {width: p0};
    });
    this._expr_42 = import1.UNINITIALIZED;
    this._expr_43 = import1.UNINITIALIZED;
    this._expr_44 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'style','margin-top: 10px'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n              ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import12.TemplateRef_(this._appEl_2,viewFactory_ImageUploadComponent4);
    this._NgIf_2_6 = new import17.Wrapper_NgIf(this._appEl_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n\n              ',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_0,'div',new import2.InlineArray2(2,'style','width: 100%; margin-top: 5px'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._el_6 = import2.createRenderElement(this.renderer,this._el_4,'div',new import2.InlineArray2(2,'class','progress progress-cover'),(null as any));
    this._NgStyle_6_3 = new import15.Wrapper_NgStyle(this.parent.parentInjector.get(import18.KeyValueDiffers),new import19.ElementRef(this._el_6),this.renderer);
    this._text_7 = this.renderer.createText(this._el_6,'\n                  ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_6,'div',new import2.InlineArray4(4,'class','progress-bar','role','progressbar'),(null as any));
    this._NgStyle_8_3 = new import15.Wrapper_NgStyle(this.parent.parentInjector.get(import18.KeyValueDiffers),new import19.ElementRef(this._el_8),this.renderer);
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import2.createRenderElement(this.renderer,this._el_8,'span',new import2.InlineArray2(2,'style','padding: 0px 3px'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                  ',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._text_14 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._el_15 = import2.createRenderElement(this.renderer,this._el_4,'div',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                  ',(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_15,'button',new import2.InlineArray4(4,'class','upload-tool btn btn-danger btn-xs','type','button'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,' ',(null as any));
    this._text_19 = this.renderer.createText(this._el_17,'\n                    ',(null as any));
    this._el_20 = import2.createRenderElement(this.renderer,this._el_17,'span',new import2.InlineArray2(2,'class','glyphicon glyphicon-trash'),(null as any));
    this._text_21 = this.renderer.createText(this._el_17,'\n                  ',(null as any));
    this._text_22 = this.renderer.createText(this._el_15,'\n                  ',(null as any));
    this._el_23 = import2.createRenderElement(this.renderer,this._el_15,'button',new import2.InlineArray4(4,'class','upload-tool btn btn-warning btn-xs','type','button'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                    ',(null as any));
    this._el_25 = import2.createRenderElement(this.renderer,this._el_23,'span',new import2.InlineArray2(2,'class','glyphicon glyphicon-ban-circle'),(null as any));
    this._text_26 = this.renderer.createText(this._el_23,'\n                  ',(null as any));
    this._text_27 = this.renderer.createText(this._el_15,'				                \n                  ',(null as any));
    this._el_28 = import2.createRenderElement(this.renderer,this._el_15,'button',new import2.InlineArray4(4,'class','upload-tool btn btn-success btn-xs','type','button'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                    ',(null as any));
    this._el_30 = import2.createRenderElement(this.renderer,this._el_28,'span',new import2.InlineArray2(2,'class','glyphicon glyphicon-upload'),(null as any));
    this._text_31 = this.renderer.createText(this._el_28,'\n                  ',(null as any));
    this._text_32 = this.renderer.createText(this._el_15,' \n                ',(null as any));
    this._text_33 = this.renderer.createText(this._el_4,'\n              ',(null as any));
    this._text_34 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_17,'click',this.eventHandler(this._handle_click_17_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_23,'click',this.eventHandler(this._handle_click_23_0.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_28,'click',this.eventHandler(this._handle_click_28_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._text_32,
      this._text_33,
      this._text_34
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import21.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.NgStyle) && ((8 <= requestNodeIndex) && (requestNodeIndex <= 12)))) { return this._NgStyle_8_3.context; }
    if (((token === import22.NgStyle) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._NgStyle_6_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parent.parent.context.tempData[this.parent.context.$implicit.options.itemAlias];
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    const currVal_6_0_0:any = this._map_40((this.parent.parent.context.thumbSize - 100));
    this._NgStyle_6_3.check_ngStyle(currVal_6_0_0,throwOnChange,false);
    this._NgStyle_6_3.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_8_0_0:any = this._map_41((this.context.$implicit.progress + '%'));
    this._NgStyle_8_3.check_ngStyle(currVal_8_0_0,throwOnChange,false);
    this._NgStyle_8_3.detectChangesInInputProps(this,this._el_8,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgStyle_6_3.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgStyle_8_3.detectChangesInHostProps(this,this._el_8,throwOnChange);
    const currVal_42:any = import2.interpolate(1,'',this.context.$implicit.progress,'%');
    if (import2.checkBinding(throwOnChange,this._expr_42,currVal_42)) {
      this.renderer.setText(this._text_11,currVal_42);
      this._expr_42 = currVal_42;
    }
    const currVal_43:boolean = !this.context.$implicit.isUploading;
    if (import2.checkBinding(throwOnChange,this._expr_43,currVal_43)) {
      this.renderer.setElementProperty(this._el_23,'disabled',currVal_43);
      this._expr_43 = currVal_43;
    }
    const currVal_44:any = ((this.context.$implicit.isReady || this.context.$implicit.isUploading) || this.context.$implicit.isSuccess);
    if (import2.checkBinding(throwOnChange,this._expr_44,currVal_44)) {
      this.renderer.setElementProperty(this._el_28,'disabled',currVal_44);
      this._expr_44 = currVal_44;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_17_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_17_0:any = ((<any>this.parent.parent.context.onRemoveImage(this.context.$implicit)) !== false);
    return (true && pd_17_0);
  }
  private _handle_click_23_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_23_0:any = ((<any>this.context.$implicit.cancel()) !== false);
    return (true && pd_23_0);
  }
  private _handle_click_28_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_28_0:any = ((<any>this.context.$implicit.upload()) !== false);
    return (true && pd_28_0);
  }
}
function viewFactory_ImageUploadComponent3(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_ImageUploadComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ImageUploadComponent4 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_ImageUploadComponent4,renderType_ImageUploadComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'img',new import2.InlineArray2(2,'class','clickLink'),(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_1:any = this.parent.parent.parent.context.tempData[this.parent.parent.context.$implicit.options.itemAlias];
    if (import2.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'src',this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL,currVal_1));
      this._expr_1 = currVal_1;
    }
    const currVal_2:any = import2.interpolate(1,'',this.parent.parent.parent.context.thumbSize,'');
    if (import2.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setElementProperty(this._el_0,'height',currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>(<_View_ImageUploadComponent1>this.parent.parent)._el_2.click()) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ImageUploadComponent4(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_ImageUploadComponent4(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/image-upload.component.ngfactory.ts